<template>
    <Modal
    :value="open"
    :onClose="close"
    :close="false"
    title="Configurações"
    >
      <b-row class="form-group">
         <b-col sm="12">
            <Label bold>Indicador de Intermediador/Marketplace</label>
            <vSelect label="name"
              v-model="indicator"
              class="busca-cliente"
              id="searchIndicator"
              ref="searchIndicator"
              :options="indicatorOptions"
            >
            </vSelect>
        </b-col>
      </b-row>
      <b-row class="form-group">
        <b-col sm="6">
          <SelectClient
            label="Intermediador da Transação"
            :client="intermediator"
            :change="changeClient"
            :disabled="disableInputs"
          />
        </b-col>
        <b-col sm="6">
          <Input
            id="username"
            ref="username"
            class="input"
            label="Nome do Usuário"
            v-model="username"
            :disabled="disableInputs"
            labelBold
          />
        </b-col>
      </b-row>
      <div class="confirm-buttons">
        <Button type="error" @click="close()">Fechar</Button>
        <Button type="success" @click="save()">Gravar</Button>
      </div>
    </Modal>
</template>

<script>
import vSelect from 'vue-select';
import { Modal } from '@/components';
import { Button, Input, Label } from '@/components/Form';
import { isCNPJ } from '@/reusable';
import { SelectClient } from '../Form';

export default {
  name: 'ModalRegisterCardManager',
  components: {
    Modal,
    Button,
    Input,
    Label,
    vSelect,
    SelectClient,
  },
  validations: {
    intermediator: {
      identification: { isCNPJ },
    },
  },
  data() {
    return {
      username: null,
      intermediator: null,
      indicator: { id: 0, name: 'Operação sem intermediador (em site ou plataforma própria)' },
      indicatorOptions: [
        {
          id: 0,
          name: 'Operação sem intermediador (em site ou plataforma própria)',
        },
        {
          id: 1,
          name: 'Operação em site ou plataforma de terceiros (intermediadores/marketplace)',
        },
      ],
      disableInputs: true,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    },
    data: {
      type: Object,
      default: null,
    },
  },
  methods: {
    async save() {
      const { indicator, intermediator, username } = this;

      const payload = { indicator };

      if (!this.disableInputs) {
        if (intermediator === null) {
          return this.$alert.error('Informe o intermediador.');
        }
        this.$v.$touch();
        if (this.$v.intermediator.$error) {
          return this.$alert.error('O intermediador precisa ter um CNPJ válido cadastrado.');
        }
        if (!username) {
          return this.$alert.error('Informe o nome do usuário.');
        }

        Object.assign(payload, {
          intermediator: {
            id: intermediator.id,
            name: intermediator.name,
            identification: intermediator.identification,
          },
          username,
        });
      }

      payload.intermediator.identification =
        this.removeIdentificationSpecialCharacters(
          payload.intermediator.identification,
        );

      return this.onSave(payload);
    },
    removeIdentificationSpecialCharacters(identification) {
      return identification.replace(/[^0-9]/g, '');
    },
    changeClient(selectedCliente) {
      this.intermediator = selectedCliente;
    },
    getFromData() {
      Object.keys(this.data).forEach((key) => {
        this[key] = this.data[key];
      });
    },
  },
  watch: {
    indicator() {
      this.disableInputs = !(this.indicator && this.indicator.id === 1);
    },
    open() {
      if (this.open) this.getFromData();
    },
  },
};
</script>
